/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getRegimenCycles } from 'app/entities/regimen-cycle/regimen-cycle.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getTreatmentRegimen } from 'app/entities/treatment-regimen/treatment-regimen.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-cycle.reducer';

export const TreatmentCycleUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const regimenCycles = useAppSelector(state => state.regimenCycle.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const treatmentRegimen = useAppSelector(state => state.treatmentRegimen.entities);
  const treatmentCycleEntity = useAppSelector(state => state.treatmentCycle.entity);
  const loading = useAppSelector(state => state.treatmentCycle.loading);
  const updating = useAppSelector(state => state.treatmentCycle.updating);
  const updateSuccess = useAppSelector(state => state.treatmentCycle.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-cycle${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getRegimenCycles({}));
    dispatch(getVitals({}));
    dispatch(getTreatmentRegimen({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cycleNumber !== undefined && typeof values.cycleNumber !== 'number') {
      values.cycleNumber = Number(values.cycleNumber);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.noOfAttempts !== undefined && typeof values.noOfAttempts !== 'number') {
      values.noOfAttempts = Number(values.noOfAttempts);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentCycleEntity,
      ...values,
      cycle: regimenCycles.find(it => it.id.toString() === values.cycle?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      regimen: treatmentRegimen.find(it => it.id.toString() === values.regimen?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentCycleEntity,
          cycle: treatmentCycleEntity?.cycle?.id,
          vitals: treatmentCycleEntity?.vitals?.id,
          regimen: treatmentCycleEntity?.regimen?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentCycle.home.createOrEditLabel" data-cy="TreatmentCycleCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentCycle.home.createOrEditLabel">Create or edit a TreatmentCycle</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-cycle-id"
                  label={translate('tinyMedicRestApp.treatmentCycle.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.cycleNumber')}
                id="treatment-cycle-cycleNumber"
                name="cycleNumber"
                data-cy="cycleNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.startDate')}
                id="treatment-cycle-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.endDate')}
                id="treatment-cycle-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.status')}
                id="treatment-cycle-status"
                name="status"
                data-cy="status"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.hasChemoPort')}
                id="treatment-cycle-hasChemoPort"
                name="hasChemoPort"
                data-cy="hasChemoPort"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.catheterSite')}
                id="treatment-cycle-catheterSite"
                name="catheterSite"
                data-cy="catheterSite"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.gauge')}
                id="treatment-cycle-gauge"
                name="gauge"
                data-cy="gauge"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.noOfAttempts')}
                id="treatment-cycle-noOfAttempts"
                name="noOfAttempts"
                data-cy="noOfAttempts"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.difficultIV')}
                id="treatment-cycle-difficultIV"
                name="difficultIV"
                data-cy="difficultIV"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.active')}
                id="treatment-cycle-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.cursor')}
                id="treatment-cycle-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.lastUpdated')}
                id="treatment-cycle-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.microSec')}
                id="treatment-cycle-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.timestampEntry')}
                id="treatment-cycle-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentCycle.notes')}
                id="treatment-cycle-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                id="treatment-cycle-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentCycle.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {regimenCycles
                  ? regimenCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-cycle-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.treatmentCycle.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-cycle-regimen"
                name="regimen"
                data-cy="regimen"
                label={translate('tinyMedicRestApp.treatmentCycle.regimen')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRegimen
                  ? treatmentRegimen.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-cycle" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentCycleUpdate;
